import fs from 'node:fs';
import type { SpawnOptions, StdioOptions } from 'node:child_process';
import {
  DEFAULT_PREVIEW_ENVIRONMENT_PROCESS_LIFECYCLE,
  previewEnvironmentSpawnOptions,
  type PreviewEnvironmentProcessLifecycle,
} from '../process-lifecycle.js';

export function mergePreviewEnvironmentSpawnOptions(
  opts: SpawnOptions,
  lifecycle: PreviewEnvironmentProcessLifecycle = DEFAULT_PREVIEW_ENVIRONMENT_PROCESS_LIFECYCLE,
): SpawnOptions {
  return { ...opts, ...previewEnvironmentSpawnOptions(lifecycle) };
}

export function isSpawnEbadf(e: unknown): boolean {
  return typeof e === 'object' && e !== null && 'code' in e && (e as NodeJS.ErrnoException).code === 'EBADF';
}

export function rmDirQuiet(dir: string): void {
  try {
    fs.rmSync(dir, { recursive: true, force: true });
  } catch {
    /* ignore */
  }
}

/** One readable fd to /dev/null (or NUL) — avoids EBADF when parent stdin is closed/invalid but libuv still mishandles `ignore` + pipes. */
let cachedDevNullReadFd: number | undefined;

export function devNullReadFd(): number {
  if (cachedDevNullReadFd === undefined) {
    const devPath = process.platform === 'win32' ? 'nul' : '/dev/null';
    cachedDevNullReadFd = fs.openSync(devPath, 'r');
  }
  return cachedDevNullReadFd;
}

export function pipedStdoutStderrFor(attemptStdio: StdioOptions): boolean {
  return (
    attemptStdio !== 'inherit' &&
    Array.isArray(attemptStdio) &&
    attemptStdio[1] === 'pipe' &&
    attemptStdio[2] === 'pipe'
  );
}
